var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.EnterReleaseNumber"),
            width: _vm.$selectByLang("300px", "380px"),
            "close-on-click-modal": false,
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.cancel
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("60px", "140px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      style: _vm.$selectByLang("", "width: 400px"),
                      attrs: { label: _vm.$t("CargoMsg.Cargo_BlReleasingNoP") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "surrenderedNo" },
                        model: {
                          value: _vm.surrenderedNo,
                          callback: function($$v) {
                            _vm.surrenderedNo = $$v
                          },
                          expression: "surrenderedNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "confirm", type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "cancel" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }